import { render, staticRenderFns } from "./SubAccountsTable.vue?vue&type=template&id=68551fdc&scoped=true&"
import script from "./SubAccountsTable.vue?vue&type=script&lang=js&"
export * from "./SubAccountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68551fdc",
  null
  
)

export default component.exports